import { PrimaryColors, typographyStyle, Colors, Flex } from '@revenuemarket/cds';
import { Menu, Typography } from 'antd';
import { MenuInfo, SelectInfo } from 'rc-menu/lib/interface';

import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { css } from '~libs/emotion';

import SearchMenuItem from './SearchMenuItem';
import { SearchMenu } from '../styles';

interface Props<T extends Record<string, unknown>> {
  onSelect: (item: SelectInfo | MenuInfo) => void;
  searchResults: FlattenTreeResult<T>[];
  selectedKey: (string | number)[] | null;
  disableActionOnInactiveItem?: boolean;
}

const SearchMenuList = <T extends Record<string, unknown>>({
  onSelect,
  searchResults,
  selectedKey,
  disableActionOnInactiveItem,
}: Props<T>) => {
  return (
    <Flex direction="column" role="menu">
      <SearchMenu
        role="menu"
        onSelect={(item) => {
          onSelect(item);
        }}
        onClick={(item) => {
          onSelect(item);
        }}
      >
        {searchResults?.length ? (
          searchResults.map((item) => {
            const namePath = item.namePath.split('.');
            const breadcrumbItems = namePath.map((key, index) => {
              return {
                key: index,
                title: (
                  <Flex
                    style={{
                      color:
                        selectedKey?.includes(item.key) && index === namePath.length - 1
                          ? PrimaryColors.primary500
                          : '',
                    }}
                  >
                    {key}
                  </Flex>
                ),
              };
            });

            const isSelected = selectedKey?.includes(item.key);
            const isDeactivated =
              (!item?.value?.isActive && disableActionOnInactiveItem) || item?.isDisabled;
            return (
              <Menu.Item
                role="menuitem"
                tabIndex={isDeactivated ? undefined : 0}
                key={item.key}
                style={{
                  width: '100%',
                }}
                disabled={isDeactivated}
                className={css`
                  &:focus-visible {
                    outline: none !important;
                    background: ${Colors.grayOpacity04};
                  }
                `}
              >
                <SearchMenuItem<T>
                  isSelected={isSelected}
                  breadcrumbItems={breadcrumbItems}
                  item={item}
                />
              </Menu.Item>
            );
          })
        ) : (
          <Flex
            style={{
              width: '100%',
              paddingTop: 8,
            }}
            justify="center"
          >
            <Typography.Text
              style={{
                ...typographyStyle['14_400'],
                color: Colors.gray500,
              }}
            >
              검색 결과가 없어요
            </Typography.Text>
          </Flex>
        )}
      </SearchMenu>
    </Flex>
  );
};

export default SearchMenuList;
